import { InjectionToken } from '@angular/core';
import { ComponentType } from 'ngx-toastr';

export const REPORT_CLONE_SUCCESS_TOAST = new InjectionToken<ComponentType<any>>('ReportCloneSuccessToast');

export enum ReportCloneEvents {
  DuplicateFailed = 'duplicate_failed',
  DuplicateCompleted = 'duplicate_completed',
}

export interface ReportCloneSuccessPayload {
  state: string;
  token: string;
  report_duplicate_token: string;
  updated_at: string;
  _links: {
    report_duplicate: {
      href: string;
    };
    web_report_duplicate: {
      href: string;
    };
    web_edit_report_duplicate: {
      href: string;
    };
  };
}
